/* eslint-disable react/jsx-props-no-spreading */
import {
    useState,
    useCallback,
} from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

import FilterPopover from './FilterPopover'

const propTypes = {
    onOpen: PropTypes.func,
    active: PropTypes.bool,
    onClose: PropTypes.func,

    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]).isRequired,
}

const defaultProps = {
    onOpen: noop,
    onClose: noop,
    active: false,
}

const FilterPopoverContainer = (props) => {
    const {
        onOpen, onClose,
    } = props

    const [
        opened,
        setState,
    ] = useState(false)

    const close = useCallback(() => {
        onClose()
        setState(false)
    }, [
        setState,
        onClose,
    ])

    const open = useCallback(() => {
        onOpen()
        setState(true)
    }, [
        setState,
        onOpen,
    ])

    return (
        <FilterPopover
            opened={opened}
            open={open}
            close={close}
            {...props}
        />
    )
}

FilterPopoverContainer.propTypes = propTypes
FilterPopoverContainer.defaultProps = defaultProps

export default FilterPopoverContainer
